import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import { all_routes } from "../../Router/all_routes";
import { DatePicker } from "antd";
import dayjs from "dayjs";

import Addunits from "../../core/modals/inventory/addunits";
import AddCategory from "../../core/modals/inventory/addcategory";
import AddBrand from "../../core/modals/addbrand";
import {
  ArrowLeft,
  Calendar,
  LifeBuoy,
  List,
  Plus,
  PlusCircle,
  Info,
} from "feather-icons-react/build/IconComponents";
import RefreshIcon from "../../core/common/tooltip-content/refresh";
import CollapesIcon from "../../core/common/tooltip-content/collapes";
import AddVariant from "../../core/modals/inventory/addvariant";
import AddVarientNew from "../../core/modals/inventory/addVarientNew";
import CommonTagsInput from "../../core/common/Taginput";
import TextEditor from "./texteditor";

import { updateProduct, uploadCatalogImage } from "../../api/productApi";
import { getAllSubCategories } from "../../api/subCategoryApi";
import { getAllStores } from "../../api/storeApi";
import { getAllWarehouses } from "../../api/warehouseApi";
import { getAllBrandsList } from "../../api/brandApi";
import { getAllUnitsList } from "../../api/unitApi";
import { getAllVariantAttributes } from "../../api/productVariantApi";
import { api } from "../../api/client";

const EditProduct = () => {
  const route = all_routes;
  const navigate = useNavigate();
  const { productId } = useParams();

  const [tags, setTags] = useState(["Red", "Black"]);
  const [product, setProduct] = useState(false);
  const [product2, setProduct2] = useState(true);

  // dropdown lists
  const [category, setCategory] = useState([]);
  const [allSubCategories, setAllSubCategories] = useState([]); // full objects (incl. parentCategory)
  const [subCategoryOptions, setSubCategoryOptions] = useState([]);
  const [storeList, setStoreList] = useState([]);
  const [warehouseList, setWarehouseList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [unitList, setUnitList] = useState([]);
  const [warrantyList, setWarrantyList] = useState([]);

  // select values
  const [storeValue, setStoreValue] = useState(null);
  const [warehouseValue, setWarehouseValue] = useState(null);
  const [sellingTypeValue, setSellingTypeValue] = useState(null);
  const [categoryValue, setCategoryValue] = useState(null);
  const [subCategoryValue, setSubCategoryValue] = useState(null);
  const [brandValue, setBrandValue] = useState(null);
  const [unitValue, setUnitValue] = useState(null);
  const [barcodeSymbologyValue, setBarcodeSymbologyValue] = useState(null);
  const [warrantyValue, setWarrantyValue] = useState(null);
  const [taxType, setTaxType] = useState(null);
  const [discountType, setDiscountType] = useState(null);

  // product fields
  const [productNameEN, setProductNameEN] = useState("");
  const [productNameAR, setProductNameAR] = useState("");
  const [slugEN, setSlugEN] = useState("");
  const [slugAR, setSlugAR] = useState("");
  const [descriptionEN, setDescriptionEN] = useState("");
  const [descriptionAR, setDescriptionAR] = useState("");
  const [manufacturerEN, setManufacturerEN] = useState("");
  const [manufacturerAR, setManufacturerAR] = useState("");
  const [sku, setSku] = useState("");
  const [itemCode, setItemCode] = useState("");
  const [price, setPrice] = useState("");
  const [quantity, setQuantity] = useState("");
  const [discountValue, setDiscountValue] = useState("");
  const [quantityAlert, setQuantityAlert] = useState("");
  const [productType, setProductType] = useState("single");
  const [manufacturedDate, setManufacturedDate] = useState(null);
  const [expiryDate, setExpiryDate] = useState(null);
  const [showVariableProduct] = useState(true);

  // variants
  const [variantAttributes, setVariantAttributes] = useState([]);
  const [selectedVariant, setSelectedVariant] = useState("");
  const [variantValues, setVariantValues] = useState([]);
  const [variantList, setVariantList] = useState([]);
  const [modalData, setModalData] = useState({});
  const [editingIndex, setEditingIndex] = useState(null);

  // images
  const [imagePreview, setImagePreview] = useState(null); // what <img> uses
  const [imageKey, setImageKey] = useState(""); // what we submit

  // raw product (for mapping after lists load)
  const [rawProduct, setRawProduct] = useState(null);

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const getDropdownOption = (list, value) =>
    list.find((item) => item.value === value);

  const IMAGE_BASE = (
    process.env.REACT_APP_API_IMAGE_BASE_URL ||
    "https://hamilton-shop-images.s3.ap-south-1.amazonaws.com"
  ).replace(/\/+$/, "");

  // keep normalizeKey as-is
  const normalizeKey = (v = "") =>
    typeof v === "string"
      ? v.replace(/^\/+/, "").replace(/^catalog\//i, "catalog/")
      : "";

  // force previews to S3 unless the value is already a full URL
  const resolveImageUrl = (key) => {
    if (!key) return "";
    const norm = normalizeKey(Array.isArray(key) ? key[0] : key);
    if (/^https?:\/\//i.test(norm)) return norm; // already absolute
    return `${IMAGE_BASE}/${norm}`;
  };

  // ---------- Reference lists (each once) ----------
  useEffect(() => {
    (async () => {
      try {
        const res = await api.get(
          `${API_BASE_URL}api/categories/category-list`
        );
        const active = (res.data || []).filter(
          (c) => c.status?.toLowerCase() === "active"
        );
        setCategory(
          active.map((cat) => ({
            value: cat.id || cat._id,
            label: cat.name || "Unnamed Category",
          }))
        );
      } catch (e) {
        console.error("Failed to load categories:", e);
      }
    })();
  }, [API_BASE_URL]);

  useEffect(() => {
    (async () => {
      try {
        const data = await getAllSubCategories();
        const active = (data || []).filter(
          (s) => s.status?.toLowerCase() === "active"
        );
        setAllSubCategories(active);
      } catch (e) {
        console.error("Error loading subcategories:", e);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const warehouses = await getAllWarehouses();
        setWarehouseList(
          (warehouses || []).map((w) => ({
            value: w.id || w._id,
            label: w.warehouseName?.en || w.warehouse || "Unnamed Warehouse",
          }))
        );
      } catch (e) {
        console.error("Failed to load warehouses:", e);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const brands = await getAllBrandsList();
        setBrandList(
          (brands || []).map((b) => ({
            value: b.id || b._id,
            label: b.brandName?.en || b.brand || "Unnamed Brand",
          }))
        );
      } catch (e) {
        console.error("Failed to load brands:", e);
        setBrandList([]);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const units = await getAllUnitsList();
        setUnitList(
          (units || []).map((u) => ({
            value: u._id || u.id,
            label: u.unitName?.en || "Unnamed Unit",
          }))
        );
      } catch (e) {
        console.error("Failed to load units:", e);
        setUnitList([]);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const resp = await api.get(`${API_BASE_URL}api/warranties`, {
          headers: {
            "Accept-Language": localStorage.getItem("lang") || "en",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        const active = (resp.data || []).filter(
          (w) => w.status?.toLowerCase() === "active"
        );
        setWarrantyList(
          active.map((w) => ({
            value: w._id || w.id,
            label: w.warrantyName?.en || w.name || "Unnamed Warranty",
          }))
        );
      } catch (e) {
        console.error("Failed to load warranties:", e);
        setWarrantyList([]);
      }
    })();
  }, [API_BASE_URL]);

  useEffect(() => {
    (async () => {
      try {
        const data = await getAllVariantAttributes();
        setVariantAttributes(data || []);
      } catch (e) {
        console.error("Error fetching variant attributes:", e);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const data = await getAllStores();
        setStoreList(
          (data || []).map((s) => ({
            value: s.id || s._id,
            label: s.CustomerName || s.storeName?.en || "Unnamed Store",
          }))
        );
      } catch (e) {
        console.error("Failed to load stores:", e);
        setStoreList([]);
      }
    })();
  }, []);

  // ---------- Load product (ONCE) ----------
  useEffect(() => {
    const controller = new AbortController();
    (async () => {
      try {
        const { data: p } = await api.get(
          `${API_BASE_URL}api/products/${productId}`,
          { signal: controller.signal }
        );
        setRawProduct(p);

        // primaries
        setProductNameEN(p.productName?.en || "");
        setProductNameAR(p.productName?.ar || "");
        setSlugEN(p.slug?.en || "");
        setSlugAR(p.slug?.ar || "");
        setDescriptionEN(p.description?.en || "");
        setDescriptionAR(p.description?.ar || "");
        setManufacturerEN(p.manufacturer?.en || "");
        setManufacturerAR(p.manufacturer?.ar || "");

        const firstKey = Array.isArray(p.images) ? p.images[0] : p.images || "";
        const normalized = normalizeKey(firstKey);
        setImageKey(normalized);
        // 👇 show existing image immediately
        setImagePreview(resolveImageUrl(normalized));

        setSku(p.sku || "");
        setItemCode(p.itemCode || "");
        setProductType(p.product?.productType || p.productType || "single");

        setPrice(p.pricing?.price ?? "");
        setQuantity(p.pricing?.quantity ?? "");
        setTaxType(
          p.pricing?.taxType
            ? { label: p.pricing.taxType, value: p.pricing.taxType }
            : null
        );
        setDiscountType(
          p.pricing?.discountType
            ? { label: p.pricing.discountType, value: p.pricing.discountType }
            : null
        );
        setDiscountValue(p.pricing?.discountValue ?? "");
        setQuantityAlert(p.pricing?.quantityAlert ?? "");

        setWarrantyValue(
          p.warranty ? { label: p.warranty, value: p.warranty } : null
        );
        setManufacturedDate(
          p.manufacturedDate ? new Date(p.manufacturedDate) : null
        );
        setExpiryDate(p.expiryDate ? new Date(p.expiryDate) : null);

        setSellingTypeValue(
          p.sellingType ? { label: p.sellingType, value: p.sellingType } : null
        );
        setBarcodeSymbologyValue(
          p.barcodeSymbology
            ? { label: p.barcodeSymbology, value: p.barcodeSymbology }
            : null
        );
      } catch (e) {
        if (e.name !== "CanceledError")
          console.error("Error fetching product:", e);
      }
    })();
    return () => controller.abort();
  }, [productId, API_BASE_URL]); // do not depend on lists here

  // ---------- Map IDs to Select values AFTER lists are ready ----------
  useEffect(() => {
    if (!rawProduct) return;
    if (storeList.length)
      setStoreValue(getDropdownOption(storeList, rawProduct.store));
    if (warehouseList.length)
      setWarehouseValue(getDropdownOption(warehouseList, rawProduct.warehouse));
    if (brandList.length)
      setBrandValue(getDropdownOption(brandList, rawProduct.brand));
    if (unitList.length)
      setUnitValue(getDropdownOption(unitList, rawProduct.unit));
    if (category.length)
      setCategoryValue(getDropdownOption(category, rawProduct.category));
  }, [rawProduct, storeList, warehouseList, brandList, unitList, category]);

  // ---------- Subcategory options derived from selected category (or product's) ----------
  useEffect(() => {
    const selectedCategoryId =
      categoryValue?.value ?? rawProduct?.category ?? null;
    if (!selectedCategoryId) {
      setSubCategoryOptions([]);
      return;
    }

    const filtered = allSubCategories
      .filter((sub) => sub.parentCategory === selectedCategoryId)
      .map((sub) => ({
        value: sub.id || sub._id,
        label:
          sub.name?.en || sub.name || sub.category || "Unnamed Subcategory",
      }));

    setSubCategoryOptions(filtered);

    if (rawProduct?.subcategory && filtered.length) {
      const match = filtered.find((o) => o.value === rawProduct.subcategory);
      if (match) setSubCategoryValue(match);
    }
  }, [categoryValue, allSubCategories, rawProduct]);

  // ---------- Variant helpers ----------
  useEffect(() => {
    if (selectedVariant && selectedVariant.values) {
      const values = selectedVariant.values || [];
      const tagsList = values.map((v) => v.en);
      setVariantValues(values);
      setTags(tagsList);

      const variants = tagsList.map((tag) => ({
        attribute: {
          en: selectedVariant.name?.en || "N/A",
          ar: selectedVariant.name?.ar || selectedVariant.name?.en || "N/A",
        },
        value: { en: tag, ar: tag },
        sku: generateRandomSku(),
        quantity: 0,
        price: 0,
        barcodeSymbology: "",
        itemCode: generateRandomItemCode(),
        discountType: "",
        discountValue: 0,
        taxType: "",
        tax: "",
        quantityAlert: 0,
        image: "",
      }));

      setVariantList(variants);
    } else {
      setVariantValues([]);
      setTags([]);
      setVariantList([]);
    }
  }, [selectedVariant]);

  useEffect(() => {
    const modalElement = document.getElementById("add-variation");
    if (modalElement && !window.bootstrap.Modal.getInstance(modalElement)) {
      new window.bootstrap.Modal(modalElement);
    }
  }, []);

  const handleVariantSubmit = (data) => {
    setVariantList((prev) => {
      const updated = [...prev];
      if (editingIndex !== null) updated[editingIndex] = data;
      else updated.push(data);
      return updated;
    });

    setModalData({});
    setEditingIndex(null);

    if (
      document.activeElement &&
      typeof document.activeElement.blur === "function"
    ) {
      document.activeElement.blur();
    }

    const modalElement = document.getElementById("add-variation");
    const oldInstance = window.bootstrap.Modal.getInstance(modalElement);
    if (oldInstance) oldInstance.dispose();
    const newInstance = new window.bootstrap.Modal(modalElement);
    newInstance.hide();

    setTimeout(() => {
      document.body.classList.remove("modal-open");
      document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
    }, 300);
  };

  const handleImageChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = async () => {
      try {
        const dataUrl = reader.result;
        setImagePreview(dataUrl);

        const ext = (file.type && file.type.split("/")[1]) || "jpg";
        const stamp = new Date()
          .toISOString()
          .replace(/[-:.TZ]/g, "")
          .slice(0, 14);
        const desiredName = `IMG_${stamp}.${ext}`;

        const { key } = await uploadCatalogImage(dataUrl, desiredName);
        const normalized = normalizeKey(key);
        setImageKey(normalized);
        // also update preview to the final served location if needed
        setImagePreview(resolveImageUrl(normalized));
      } catch (err) {
        console.error(err);
        alert(window.translate("Image upload failed"));
        setImagePreview(null);
        setImageKey("");
      }
    };
    reader.readAsDataURL(file);
  };

  const handleRemoveImage = () => {
    setImagePreview(null);
    setImageKey("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const product = {
      store: storeValue?.value || "",
      warehouse: warehouseValue?.value || "",
      productName: { en: productNameEN, ar: productNameAR },
      slug: { en: slugEN, ar: slugAR },
      sku,
      itemCode,
      description: { en: descriptionEN, ar: descriptionAR },
      sellingType: sellingTypeValue?.value || "",
      category: categoryValue?.value || "",
      subcategory: subCategoryValue?.value || "",
      brand: brandValue?.value || "",
      unit: unitValue?.value || "",
      barcodeSymbology: barcodeSymbologyValue?.value || "",
      warranty: warrantyValue?.value || "",
      manufacturer: { en: manufacturerEN, ar: manufacturerAR },
      manufacturedDate,
      expiryDate,
      hasWarranty: !!warrantyValue,
      hasManufacturer: !!manufacturerEN || !!manufacturerAR,
      hasExpiry: !!expiryDate,
      productType,
      images: normalizeKey(imageKey || ""), // submit key, not preview URL
    };

    const pricing = {
      productType,
      quantity: parseInt(quantity) || 0,
      price: parseFloat(price) || 0,
      taxType: taxType?.value || "",
      discountType: discountType?.value || "",
      discountValue: parseFloat(discountValue) || 0,
      quantityAlert: parseInt(quantityAlert) || 0,
    };

    const payload = {
      product,
      pricing,
      variantAttributes:
        productType === "variable" && selectedVariant?.name?._id
          ? [selectedVariant.name._id]
          : [],
      variants: productType === "variable" ? variantList : [],
    };

    const result = await updateProduct(productId, payload);
    if (result.success) {
      alert(window.translate("✅ Product edit successfully!"));
      navigate("/product-list");
    } else {
      alert(`❌ ${window.translate("Failed to add product")}: ${result.error}`);
    }
  };

  const generateRandomSku = () => {
    const prefix = "SKU";
    const randomNum = Math.floor(100000 + Math.random() * 900000);
    return `${prefix}-${randomNum}`;
  };

  const generateRandomItemCode = () => {
    const prefix = "ITM";
    const randomNum = Math.floor(100000 + Math.random() * 900000);
    return `${prefix}-${randomNum}`;
  };

  const sellingtype = [
    { value: "transactionalSelling", label: "Transactional selling" },
    { value: "solutionSelling", label: "Solution selling" },
  ];
  const barcodesymbol = [
    { value: "code34", label: "Code34" },
    { value: "code35", label: "Code35" },
    { value: "code36", label: "Code36" },
  ];
  const taxtype = [
    { value: "exclusive", label: "Exclusive" },
    { value: "salesTax", label: "Sales Tax" },
  ];
  const discounttype = [
    { value: "choose", label: "Choose" },
    { value: "percentage", label: "Percentage" },
    { value: "cash", label: "Cash" },
  ];

  const close = () => navigate("/product-list");

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>{window.translate("Edit Product")}</h4>
              </div>
            </div>
            <ul className="table-top-head">
              <RefreshIcon />
              <CollapesIcon />
              <li>
                <div className="page-btn">
                  <Link to={route.productlist} className="btn btn-secondary">
                    <ArrowLeft className="me-2" />
                    {window.translate("Back to Product")}
                  </Link>
                </div>
              </li>
            </ul>
          </div>

          <form className="add-product-form" onSubmit={handleSubmit}>
            <div className="add-product">
              <div
                className="accordions-items-seperate"
                id="accordionSpacingExample"
              >
                {/* Product Information */}
                <div className="accordion-item border mb-4">
                  <h2 className="accordion-header" id="headingSpacingOne">
                    <div
                      className="accordion-button collapsed bg-white"
                      data-bs-toggle="collapse"
                      data-bs-target="#SpacingOne"
                      aria-expanded="true"
                      aria-controls="SpacingOne"
                    >
                      <div className="d-flex align-items-center justify-content-between flex-fill">
                        <h5 className="d-flex align-items-center gap-2">
                          <Info className="text-primary me-2" />
                          <span>{window.translate("Product Information")}</span>
                        </h5>
                      </div>
                    </div>
                  </h2>
                  <div
                    id="SpacingOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingSpacingOne"
                  >
                    <div className="accordion-body border-top">
                      <div className="row">
                        <div className="col-sm-6 col-12">
                          <div className="mb-3">
                            <label className="form-label">
                              {window.translate("Store")}{" "}
                              <span className="text-danger ms-1">*</span>
                            </label>
                            <Select
                              classNamePrefix="react-select"
                              options={storeList}
                              placeholder="Choose"
                              value={storeValue}
                              onChange={setStoreValue}
                            />
                          </div>
                        </div>
                        <div className="col-sm-6 col-12">
                          <div className="mb-3">
                            <label className="form-label">
                              {window.translate("Warehouse")}{" "}
                              <span className="text-danger ms-1">*</span>
                            </label>
                            <Select
                              classNamePrefix="react-select"
                              options={warehouseList}
                              placeholder="Choose"
                              value={warehouseValue}
                              onChange={setWarehouseValue}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-sm-6 col-12">
                          <div className="mb-3">
                            <label className="form-label">
                              {window.translate("Product Name (EN)")}{" "}
                              <span className="text-danger ms-1">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={productNameEN}
                              onChange={(e) => setProductNameEN(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-sm-6 col-12">
                          <div className="mb-3">
                            <label className="form-label">
                              {window.translate("Product Name (AR)")}{" "}
                              <span className="text-danger ms-1">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={productNameAR}
                              onChange={(e) => setProductNameAR(e.target.value)}
                            />
                          </div>
                        </div>

                        <div className="col-sm-6 col-12">
                          <div className="mb-3">
                            <label className="form-label">
                              {window.translate("Slug (EN)")}{" "}
                              <span className="text-danger ms-1">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={slugEN}
                              onChange={(e) => setSlugEN(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-sm-6 col-12">
                          <div className="mb-3">
                            <label className="form-label">
                              {window.translate("Slug (AR)")}{" "}
                              <span className="text-danger ms-1">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={slugAR}
                              onChange={(e) => setSlugAR(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-sm-6 col-12">
                          <div className="mb-3 list position-relative">
                            <label className="form-label">
                              {window.translate("SKU")}{" "}
                              <span className="text-danger ms-1">*</span>
                            </label>
                            <input
                              type="text"
                              style={{ paddingRight: "50px" }}
                              className="form-control list"
                              value={sku}
                              onChange={(e) => setSku(e.target.value)}
                            />
                            <button
                              type="button"
                              className="btn btn-primaryadd"
                              onClick={() => setSku(generateRandomSku())}
                            >
                              {window.translate("Generate")}
                            </button>
                          </div>
                        </div>
                        <div className="col-sm-6 col-12">
                          <div className="mb-3">
                            <label className="form-label">
                              {window.translate("Selling Type")}{" "}
                              <span className="text-danger ms-1">*</span>
                            </label>
                            <Select
                              classNamePrefix="react-select"
                              options={sellingtype}
                              placeholder="Choose"
                              value={sellingTypeValue}
                              onChange={setSellingTypeValue}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="addservice-info">
                        <div className="row">
                          <div className="col-sm-6 col-12">
                            <div className="mb-3">
                              <div className="add-newplus">
                                <label className="form-label">
                                  {window.translate("Category")}{" "}
                                  <span className="text-danger ms-1">*</span>
                                </label>
                              </div>
                              <Select
                                classNamePrefix="react-select"
                                options={category}
                                placeholder="Choose"
                                value={categoryValue}
                                onChange={(opt) => setCategoryValue(opt)}
                              />
                            </div>
                          </div>
                          <div className="col-sm-6 col-12">
                            <div className="mb-3">
                              <label className="form-label">
                                {window.translate("Sub Category")}{" "}
                                <span className="text-danger ms-1">*</span>
                              </label>
                              <Select
                                classNamePrefix="react-select"
                                options={subCategoryOptions}
                                placeholder="Choose"
                                value={subCategoryValue}
                                onChange={setSubCategoryValue}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="add-product-new">
                        <div className="row">
                          <div className="col-sm-6 col-12">
                            <div className="mb-3">
                              <div className="add-newplus">
                                <label className="form-label">
                                  {window.translate("Brand")}{" "}
                                  <span className="text-danger ms-1">*</span>
                                </label>
                              </div>
                              <Select
                                classNamePrefix="react-select"
                                options={brandList}
                                placeholder="Choose"
                                value={brandValue}
                                onChange={setBrandValue}
                              />
                            </div>
                          </div>
                          <div className="col-sm-6 col-12">
                            <div className="mb-3">
                              <div className="add-newplus">
                                <label className="form-label">
                                  {window.translate("Unit")}{" "}
                                  <span className="text-danger ms-1">*</span>
                                </label>
                              </div>
                              {unitList.length === 0 ? (
                                <div>
                                  {window.translate("Loading units...")}
                                </div>
                              ) : (
                                <Select
                                  options={unitList}
                                  value={unitValue}
                                  onChange={setUnitValue}
                                  placeholder="Choose Unit"
                                  isClearable
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-lg-6 col-sm-6 col-12">
                          <div className="mb-3">
                            <label className="form-label">
                              {window.translate("Barcode Symbology")}{" "}
                              <span className="text-danger ms-1">*</span>
                            </label>
                            <Select
                              classNamePrefix="react-select"
                              options={barcodesymbol}
                              placeholder="Choose"
                              value={barcodeSymbologyValue}
                              onChange={setBarcodeSymbologyValue}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-sm-6 col-12">
                          <div className="mb-3 list position-relative">
                            <label className="form-label">
                              {window.translate("Item Code")}{" "}
                              <span className="text-danger ms-1">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control list"
                              style={{ paddingRight: "50px" }}
                              value={itemCode}
                              onChange={(e) => setItemCode(e.target.value)}
                            />
                            <button
                              type="button"
                              className="btn btn-primaryadd"
                              onClick={() =>
                                setItemCode(generateRandomItemCode())
                              }
                            >
                              {window.translate("Generate")}
                            </button>
                          </div>
                        </div>
                      </div>

                      {/* Descriptions */}
                      <div className="col-lg-12">
                        <div className="summer-description-box">
                          <label className="form-label">
                            {window.translate("description")} (EN)
                          </label>
                          <TextEditor
                            value={descriptionEN}
                            onChange={(v) => setDescriptionEN(v)}
                          />
                          <p className="fs-14 mt-1">
                            {window.translate("Maximum 60 Words")}
                          </p>
                        </div>
                      </div>

                      <div className="col-lg-12">
                        <div className="summer-description-box">
                          <label className="form-label">
                            {window.translate("description")} (AR)
                          </label>
                          <TextEditor
                            value={descriptionAR}
                            onChange={(v) => setDescriptionAR(v)}
                          />
                          <p className="fs-14 mt-1">
                            {window.translate("Maximum 60 Words")}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Pricing & Stocks */}
                <div className="accordion-item border mb-4">
                  <h2 className="accordion-header" id="headingSpacingTwo">
                    <div
                      className="accordion-button collapsed bg-white"
                      data-bs-toggle="collapse"
                      data-bs-target="#SpacingTwo"
                      aria-expanded="true"
                      aria-controls="SpacingTwo"
                    >
                      <div className="d-flex align-items-center justify-content-between flex-fill">
                        <h5 className="d-flex align-items-center gap-2">
                          <LifeBuoy className="text-primary me-2" />
                          <span>
                            {window.translate("Pricing")} &amp;{" "}
                            {window.translate("Stocks")}
                          </span>
                        </h5>
                      </div>
                    </div>
                  </h2>
                  <div
                    id="SpacingTwo"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingSpacingTwo"
                  >
                    <div className="accordion-body border-top">
                      <div className="mb-3s">
                        <label className="form-label">
                          {window.translate("Product Type")}{" "}
                          <span className="text-danger ms-1">*</span>
                        </label>
                        <div className="single-pill-product mb-3">
                          <ul
                            className="nav nav-pills"
                            id="pills-tab1"
                            role="tablist"
                          >
                            <li className="nav-item" role="presentation">
                              <span
                                className={`custom_radio me-4 mb-0 ${
                                  productType === "single" ? "active" : ""
                                }`}
                                onClick={() => setProductType("single")}
                              >
                                <input
                                  type="radio"
                                  className="form-control"
                                  name="productType"
                                  value="single"
                                  checked={productType === "single"}
                                  onChange={(e) =>
                                    setProductType(e.target.value)
                                  }
                                />
                                <span className="checkmark" />{" "}
                                {window.translate("Single Product")}
                              </span>
                            </li>
                            {showVariableProduct && (
                              <li className="nav-item" role="presentation">
                                <span
                                  className={`custom_radio me-2 mb-0 ${
                                    productType === "variable" ? "active" : ""
                                  }`}
                                  onClick={() => setProductType("variable")}
                                >
                                  <input
                                    type="radio"
                                    className="form-control"
                                    name="productType"
                                    value="variable"
                                    checked={productType === "variable"}
                                    onChange={(e) =>
                                      setProductType(e.target.value)
                                    }
                                  />
                                  <span className="checkmark" />{" "}
                                  {window.translate("Variable Product")}
                                </span>
                              </li>
                            )}
                          </ul>
                        </div>
                      </div>

                      <div className="tab-content" id="pills-tabContent">
                        {/* Single product pricing */}
                        <div
                          className={`tab-pane fade ${
                            productType === "single" ? "show active" : ""
                          }`}
                          id="pills-home"
                          role="tabpanel"
                        >
                          <div className="single-product">
                            <div className="row">
                              <div className="col-lg-4 col-sm-6 col-12">
                                <div className="mb-3">
                                  <label className="form-label">
                                    {window.translate("Quantity")}{" "}
                                    <span className="text-danger ms-1">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={quantity}
                                    onChange={(e) =>
                                      setQuantity(e.target.value)
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-lg-4 col-sm-6 col-12">
                                <div className="mb-3">
                                  <label className="form-label">
                                    {window.translate("Price")}{" "}
                                    <span className="text-danger ms-1">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={price}
                                    onChange={(e) => setPrice(e.target.value)}
                                  />
                                </div>
                              </div>
                              <div className="col-lg-4 col-sm-6 col-12">
                                <div className="mb-3">
                                  <label className="form-label">
                                    {window.translate("Tax Type")}{" "}
                                    <span className="text-danger ms-1">*</span>
                                  </label>
                                  <Select
                                    classNamePrefix="react-select"
                                    options={taxtype}
                                    placeholder="Select Option"
                                    value={taxType}
                                    onChange={setTaxType}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-4 col-sm-6 col-12">
                                <div className="mb-3">
                                  <label className="form-label">
                                    {window.translate("Discount Type")}{" "}
                                    <span className="text-danger ms-1">*</span>
                                  </label>
                                  <Select
                                    classNamePrefix="react-select"
                                    options={discounttype}
                                    placeholder="Choose"
                                    value={discountType}
                                    onChange={setDiscountType}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                    menuPortalTarget={document.body}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-4 col-sm-6 col-12">
                                <div className="mb-3">
                                  <label className="form-label">
                                    {window.translate("Discount Value")}{" "}
                                    <span className="text-danger ms-1">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={discountValue}
                                    onChange={(e) =>
                                      setDiscountValue(e.target.value)
                                    }
                                  />
                                </div>
                              </div>

                              <div className="col-lg-4 col-sm-6 col-12">
                                <div className="mb-3">
                                  <label className="form-label">
                                    {window.translate("Quantity Alert")}{" "}
                                    <span className="text-danger ms-1">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={quantityAlert}
                                    onChange={(e) =>
                                      setQuantityAlert(e.target.value)
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Variable product */}
                        <div
                          className={`tab-pane fade ${
                            productType === "variable" ? "show active" : ""
                          }`}
                          id="pills-profile"
                          role="tabpanel"
                        >
                          <div className="row select-color-add">
                            <div className="col-lg-6 col-sm-6 col-12">
                              <div className="mb-3">
                                <label className="form-label">
                                  {window.translate("Variant Attribute")}{" "}
                                  <span className="text-danger ms-1">*</span>
                                </label>
                                <div className="row">
                                  <div className="col-lg-10 col-sm-10 col-10">
                                    <select
                                      className="form-control variant-select select-option"
                                      onChange={(e) => {
                                        const selected = variantAttributes.find(
                                          (attr) =>
                                            attr.name?._id &&
                                            String(attr.name._id) ===
                                              e.target.value
                                        );
                                        setSelectedVariant(selected);
                                        setProduct(true);
                                      }}
                                    >
                                      <option value="">
                                        {window.translate("Choose")}
                                      </option>
                                      {variantAttributes.map((attribute) => (
                                        <option
                                          key={attribute.name?._id}
                                          value={attribute.name?._id}
                                        >
                                          {attribute.name?.en}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                  <div className="col-lg-2 col-sm-2 col-2 ps-0">
                                    <div className="add-icon tab">
                                      <Link
                                        className="btn btn-filter"
                                        data-bs-toggle="modal"
                                        data-bs-target="#add-units"
                                      >
                                        <i className="feather feather-plus-circle" />
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {product && (
                                <div
                                  className={`selected-hide-color ${
                                    product2 ? "d-block" : ""
                                  }`}
                                  id="input-show"
                                >
                                  <label className="form-label">
                                    {window.translate("Variant Attribute Tag")}{" "}
                                    <span className="text-danger ms-1">*</span>
                                  </label>
                                  <div className="row align-items-center">
                                    <div className="col-lg-10 col-sm-10 col-10">
                                      <div className="mb-3">
                                        <CommonTagsInput
                                          value={tags}
                                          suggestions={variantValues.map(
                                            (v) => v.en
                                          )}
                                          onChange={setTags}
                                          placeholder="Add new"
                                          className="input-tags form-control"
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-2 col-sm-2 col-2 ps-0">
                                      <div className="mb-3 ">
                                        <Link
                                          to="#"
                                          className="remove-color"
                                          onClick={() => setProduct2(false)}
                                        >
                                          <i className="far fa-trash-alt" />
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>

                          {product && (
                            <div
                              className="modal-body-table variant-table d-block"
                              id="variant-table"
                            >
                              <div className="table-responsive">
                                <table className="table">
                                  <thead>
                                    <tr>
                                      <th>{window.translate("Variantion")}</th>
                                      <th>
                                        {window.translate("Variant Value")}
                                      </th>
                                      <th>{window.translate("SKU")}</th>
                                      <th>{window.translate("Quantity")}</th>
                                      <th>{window.translate("Price")}</th>
                                      <th className="no-sort" />
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {variantList.map((variant, index) => (
                                      <tr key={index}>
                                        <td>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={
                                              variant.attribute?.en || "Variant"
                                            }
                                            readOnly
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={variant.value?.en || ""}
                                            readOnly
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={variant.sku || ""}
                                            readOnly
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={variant.price || ""}
                                            onChange={(e) => {
                                              const updated = [...variantList];
                                              updated[index].price =
                                                e.target.value;
                                              setVariantList(updated);
                                            }}
                                          />
                                        </td>
                                        <td className="action-table-data">
                                          <div className="edit-delete-action">
                                            <Link
                                              to="#"
                                              className="me-2 p-2"
                                              data-bs-toggle="modal"
                                              data-bs-target="#add-variation"
                                              onClick={() => {
                                                setEditingIndex(index);
                                                setModalData(variant);
                                              }}
                                            >
                                              <Plus className="feather-edit" />
                                            </Link>
                                            <Link
                                              to="#"
                                              className="p-2"
                                              onClick={() => {
                                                const newList = [
                                                  ...variantList,
                                                ];
                                                newList.splice(index, 1);
                                                setVariantList(newList);
                                              }}
                                            >
                                              <i className="feather-trash-2" />
                                            </Link>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Images */}
                <div className="accordion-item border mb-4">
                  <h2 className="accordion-header" id="headingSpacingThree">
                    <div
                      className="accordion-button collapsed bg-white"
                      data-bs-toggle="collapse"
                      data-bs-target="#SpacingThree"
                      aria-expanded="true"
                      aria-controls="SpacingThree"
                    >
                      <div className="d-flex align-items-center justify-content-between flex-fill">
                        <h5 className="d-flex align-items-center">
                          <span>{window.translate("Images")}</span>
                        </h5>
                      </div>
                    </div>
                  </h2>
                  <div
                    id="SpacingThree"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingSpacingThree"
                  >
                    <div className="accordion-body border-top">
                      <div className="text-editor add-list add">
                        <div className="col-lg-12">
                          <div className="add-choosen">
                            <div className="mb-3">
                              <div className="image-uploads">
                                <input
                                  type="file"
                                  accept="image/*"
                                  onChange={handleImageChange}
                                  id="imageUploadInput"
                                  style={{ display: "none" }}
                                />

                                <label
                                  htmlFor="imageUploadInput"
                                  className="image-uploads d-flex justify-content-center align-items-center"
                                  style={{
                                    width: "150px",
                                    height: "150px",
                                    backgroundColor: "#f3f8f9",
                                    border: "1px dashed #ccc",
                                    borderRadius: "10px",
                                    position: "relative",
                                    overflow: "hidden",
                                  }}
                                >
                                  {imagePreview ? (
                                    <>
                                      <img
                                        src={imagePreview}
                                        alt="Preview"
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          objectFit: "cover",
                                          borderRadius: "10px",
                                        }}
                                      />
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-danger position-absolute"
                                        style={{
                                          top: "6px",
                                          right: "6px",
                                          width: "24px",
                                          height: "24px",
                                          padding: 0,
                                          borderRadius: "50%",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          fontSize: "16px",
                                        }}
                                        onClick={handleRemoveImage}
                                        title="Remove image"
                                      >
                                        ×
                                      </button>
                                    </>
                                  ) : (
                                    <div className="text-center">
                                      <PlusCircle className="mb-1" />
                                      <h6 className="m-0">
                                        {window.translate("Add Images")}
                                      </h6>
                                    </div>
                                  )}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Custom Fields */}
                <div className="accordion-item border mb-4">
                  <h2 className="accordion-header" id="headingSpacingFour">
                    <div
                      className="accordion-button collapsed bg-white"
                      data-bs-toggle="collapse"
                      data-bs-target="#SpacingFour"
                      aria-expanded="true"
                      aria-controls="SpacingFour"
                    >
                      <div className="d-flex align-items-center justify-content-between flex-fill">
                        <h5 className="d-flex align-items-center gap-2">
                          <List className="text-primary me-2" />
                          <span>{window.translate("Custom Fields")}</span>
                        </h5>
                      </div>
                    </div>
                  </h2>
                  <div
                    id="SpacingFour"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingSpacingFour"
                  >
                    <div className="accordion-body border-top">
                      <div>
                        <div className="p-3 bg-light rounded d-flex align-items-center border mb-3">
                          <div className=" d-flex align-items-center">
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="warranties"
                                defaultValue="option1"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="warranties"
                              >
                                {window.translate("Warranties")}
                              </label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="manufacturer"
                                defaultValue="option2"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="manufacturer"
                              >
                                {window.translate("Manufacturer")}
                              </label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="expiry"
                                defaultValue="option2"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="expiry"
                              >
                                {window.translate("Expiry")}
                              </label>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-4 col-sm-6 col-12">
                            <div className="mb-3">
                              <label className="form-label">
                                {window.translate("Warranties")}{" "}
                                <span className="text-danger ms-1">*</span>
                              </label>
                              <Select
                                classNamePrefix="react-select"
                                options={warrantyList}
                                placeholder="Choose"
                                value={warrantyValue}
                                onChange={setWarrantyValue}
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-sm-6 col-12">
                            <div className="mb-3 add-product">
                              <label className="form-label">
                                {window.translate("Manufacturer")} (EN){" "}
                                <span className="text-danger ms-1">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={manufacturerEN}
                                onChange={(e) =>
                                  setManufacturerEN(e.target.value)
                                }
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-sm-6 col-12">
                            <div className="mb-3 add-product">
                              <label className="form-label">
                                {window.translate("Manufacturer")} (AR){" "}
                                <span className="text-danger ms-1">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={manufacturerAR}
                                onChange={(e) =>
                                  setManufacturerAR(e.target.value)
                                }
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-6 col-12">
                            <div className="mb-3">
                              <label className="form-label">
                                {window.translate("Manufactured On")}{" "}
                                <span className="text-danger ms-1">*</span>
                              </label>
                              <div className="input-groupicon calender-input">
                                <Calendar className="info-img" />
                                <DatePicker
                                  className="form-control datetimepicker"
                                  placeholder="dd/mm/yyyy"
                                  value={
                                    manufacturedDate
                                      ? dayjs(manufacturedDate)
                                      : null
                                  }
                                  onChange={(d) =>
                                    setManufacturedDate(d ? d.toDate() : null)
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-6 col-12">
                            <div className="mb-3">
                              <label className="form-label">
                                {window.translate("Expiry On")}{" "}
                                <span className="text-danger ms-1">*</span>
                              </label>
                              <div className="input-groupicon calender-input">
                                <Calendar className="info-img" />
                                <DatePicker
                                  className="form-control datetimepicker"
                                  placeholder="dd/mm/yyyy"
                                  value={expiryDate ? dayjs(expiryDate) : null}
                                  onChange={(d) =>
                                    setExpiryDate(d ? d.toDate() : null)
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer buttons */}
            <div className="col-lg-12">
              <div className="d-flex align-items-center justify-content-end mb-4 gap-2">
                <button
                  type="button"
                  className="btn btn-secondary me-2"
                  onClick={close}
                  value="Cancel"
                >
                  {window.translate("Cancel")}
                </button>
                <button type="submit" className="btn btn-primary">
                  {window.translate("Edit Product")}
                </button>
              </div>
            </div>
          </form>
        </div>

        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0 text-gray-9">
            {window.translate("2024-2025 © Hamilton POS. All Right Reserved")}
          </p>
          <p>
            {window.translate("Designed & Developed By")}{" "}
            <Link to="#" className="text-primary">
              {window.translate("Hamilton")}
            </Link>
          </p>
        </div>
      </div>

      {/* Modals */}
      <Addunits />
      <AddCategory />
      <AddVariant />
      <AddBrand />

      <AddVarientNew
        modalData={modalData}
        setModalData={setModalData}
        onSubmit={handleVariantSubmit}
      />

      <div className="modal fade" id="delete-modal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content p-5 px-3 text-center">
                <span className="rounded-circle d-inline-flex p-2 bg-danger-transparent mb-2">
                  <i className="ti ti-trash fs-24 text-danger"></i>
                </span>
                <h4 className="fs-20 fw-bold mb-2 mt-1">
                  {window.translate("Delete")}
                </h4>
                <p className="mb-0 fs-16">
                  {window.translate(
                    "Are you sure you want to delete Attribute?"
                  )}
                </p>
                <div className="modal-footer-btn mt-3 d-flex justify-content-center">
                  <button
                    type="button"
                    className="btn me-2 btn-secondary fs-13 fw-medium p-2 px-3 shadow-none"
                    data-bs-dismiss="modal"
                  >
                    {window.translate("Cancel")}
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary fs-13 fw-medium p-2 px-3"
                  >
                    {window.translate("Yes Delete")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditProduct;
